import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {convertConditionAPICardToAICard} from '../../../../tools/general/addOrUpdateCardTool/schemaConverters/conditionCard/convertConditionAPICardToAICard';
import {convertScheduleAPICardToAICard} from '../../../../tools/general/addOrUpdateCardTool/schemaConverters/scheduleCard/convertScheduleAPICardToAICard';
import {convertWeightedAPICardToAICard} from '../../../../tools/general/addOrUpdateCardTool/schemaConverters/weightedCard/convertWeightedAPICardToAICard';
import {convertOptimizationAPICardToAICard} from '../../../../tools/general/addOrUpdateCardTool/schemaConverters/optimizationCard/convertOptimizationAPICardToAICard';
import {z} from 'zod';
import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {ConditionCardScratchpadState} from '../../scratchpad/conditionCardScratchpad.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  DTScheduleNode,
  DTWeightedNode,
  DTOptimizationNode,
} from 'common/src/modules/decisionTree/decisionTree.types';

export default function getCardDetailsTool() {
  async function execute(
    params: ToolExecuteParams<z.ZodObject<Record<string, never>>, BaseCardScratchpadState>,
  ) {
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<BaseCardScratchpadState>(agentScratchpad);
    const {card} = validatedScratchpad;

    if (card.type === NodeType.SCHEDULE) {
      const aiSchema = convertScheduleAPICardToAICard(card as DTScheduleNode);

      return toolResult(JSON.stringify(aiSchema));
    }

    if (card.type === NodeType.CONDITION) {
      const conditionScratchpad = validatedScratchpad as ConditionCardScratchpadState;
      const aiSchema = convertConditionAPICardToAICard(conditionScratchpad.card);
      const extendedAiSchema = {
        ...aiSchema,
        optionalOperators: conditionScratchpad.card.optionalOperators || [],
        shouldQueryOptionalValues: conditionScratchpad.card.shouldQueryOptionalValues || false,
      };

      return toolResult(JSON.stringify(extendedAiSchema));
    }

    if (card.type === NodeType.WEIGHTED) {
      const aiSchema = convertWeightedAPICardToAICard(card as DTWeightedNode);

      return toolResult(JSON.stringify(aiSchema));
    }

    if (card.type === NodeType.GENERAL_OPTIMIZATION) {
      const aiSchema = convertOptimizationAPICardToAICard(card as DTOptimizationNode);

      return toolResult(JSON.stringify(aiSchema));
    }

    return toolResult(
      JSON.stringify({
        status: 'error',
        message: `Unsupported card type for getCardDetails: ${card.type}`,
      }),
    );
  }

  return tool<z.ZodObject<Record<string, never>>, BaseCardScratchpadState>({
    name: V2CardAgentToolName.GetCardDetails,
    description: 'Retrieves full details of a card by its ID.',
    displayName: 'Getting card details',
    inputSchema: z.object({}),
    execute,
  });
}
